import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import { Link, useParams } from 'react-router-dom';
import './Ticket.css'; // Import the stylesheet

// Helper function to format the date and time
const formatDateTime = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  const options = {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true
  };
  return date.toLocaleString('en-US', options);
};

// Helper to check for valid string content from the API
const isValidString = (str) => {
  return str && str !== 'string';
};

function JobManagement({ createdBy }) {
  const [jobs, setJobs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { jobRunId } = useParams();

  useEffect(() => {
    if (!createdBy) {
      setError("No user ID provided in the URL.");
      setIsLoading(false);
      return;
    }

    const controller = new AbortController();

    const fetchJobs = async () => {
      try {
        setIsLoading(true);
        setError(null);
        // Use the pre-configured apiClient. The base URL is handled automatically.
        const response = await apiClient.get(`/api/v2/jobs?createdBy=${createdBy}`, {
          signal: controller.signal,
        });
        setJobs(response.data);
      } catch (err) {
        if (apiClient.isCancel(err)) { // Use isCancel from the apiClient instance
          console.log('Request canceled', err.message);
        } else {
          setError('Failed to fetch the list of tickets for this user.');
          console.error(err);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchJobs();

    return () => {
      controller.abort();
    };
  }, [createdBy]);

  return (
    <div className="section ticket-list">
      <h2>All Tickets</h2>
      {isLoading && <div>Loading tickets...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {!isLoading && !error && jobs.length === 0 && <div>No tickets found for this user.</div>}
      {!isLoading && !error && jobs.map(job => (
        <Link to={`/trustUserTicketStatus/${job.jobRunId}?id=${createdBy}`} key={job.jobRunId} className={`ticket-row ${job.jobRunId === jobRunId ? 'selected' : ''}`}>
          <div>
            <strong>#{job.jobRunId.substring(4, 10)}</strong>: {isValidString(job.jobTitle) ? job.jobTitle : job.jobName}
            {isValidString(job.jobDescription) && (
              <div style={{ fontSize: '0.9em', color: '#555', marginTop: '5px' }}>
                {job.jobDescription}
              </div>
            )}
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '0.85em', color: '#5f6368' }}>
              {formatDateTime(job.startTime)}
            </div>
            <span className={`badge status-${job.status.toLowerCase()}`} style={{ marginTop: '4px' }}>
              {job.status}
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}

export default JobManagement;
